import "./TwoTopOneBottomLayoutComponent.scss";
import template from "./TwoTopOneBottomLayoutComponent.html";
import {IComponentOptions} from "angular";
import {Observable} from "rxjs";
import {WidgetDisplayMode} from "../../../models/WidgetDisplayMode";
import {BreakpointObserver} from "../../../../../services/breakpoints/BreakpointObserver";
import {Breakpoint} from "../../../../../services/breakpoints/Breakpoint";

export const TwoTopOneBottomLayout = "tfTwoTopOneBottomLayout";

export function twoTopOneBottom(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: TwoTopOneBottomLayoutComponent
    };
}

export class TwoTopOneBottomLayoutComponent {

    public readonly topWidgetsDisplay$: Observable<WidgetDisplayMode>;

    /** @ngInject */
    public constructor(private readonly breakpointObserver: BreakpointObserver) {
        this.topWidgetsDisplay$ = this.buildTopWidgetsDisplay();
    }

    private buildTopWidgetsDisplay(): Observable<WidgetDisplayMode> {
        return this.breakpointObserver.observe(Breakpoint.WebLandscape)
                   .map((bp) => bp.active)
                   .map((active) => active ? WidgetDisplayMode.WIDE : WidgetDisplayMode.TALL)
                   .publishReplay(1)
                   .refCount();
    }
}
